/**
 * =============================================================================
 * USE COOKIES - Hook para aceder ao CookieContext
 * =============================================================================
 *
 * Hook simples e tipado para consumir o consentimento de cookies
 * em qualquer componente React.
 */

import { useContext } from "react";
import { CookieContext } from "@/context/CookieContext";

export function useCookies() {
  const context = useContext(CookieContext);
  if (!context) {
    throw new Error("useCookies deve ser usado dentro de um CookieProvider");
  }
  return context;
}

export default useCookies;
